import { __decorate, __param } from 'tslib';
import { Injectable, Optional } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Subject, of } from 'rxjs';
import { tap, share, filter, map } from 'rxjs/operators';
import { deepClone, compare, applyPatch } from 'fast-json-patch';
import { Guid } from 'guid-typescript';

import * as ɵngcc0 from '@angular/core';
let RepositoryConfig = class RepositoryConfig {
    constructor() {
        this.apiBase = "";
    }
};
RepositoryConfig.ɵfac = function RepositoryConfig_Factory(t) { return new (t || RepositoryConfig)(); };
RepositoryConfig.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: RepositoryConfig, factory: function (t) { return RepositoryConfig.ɵfac(t); } });
let PatchFeed = class PatchFeed {
};
PatchFeed.ɵfac = function PatchFeed_Factory(t) { return new (t || PatchFeed)(); };
PatchFeed.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: PatchFeed, factory: function (t) { return PatchFeed.ɵfac(t); } });
class Repository {
    constructor(config, http, endpoint) {
        this.config = config;
        this.http = http;
        this.endpoint = endpoint;
        this.clientTag = Guid.create().toString();
        this.http = http;
    }
}
let EntityRepository = class EntityRepository extends Repository {
    constructor(config, http, endpoint, patchFeed = null) {
        var _a, _b;
        super(config, http, endpoint);
        this.config = config;
        this.endpoint = endpoint;
        this.patchFeed = patchFeed;
        this.audienceAvailable = false;
        this.audienceRequiresId = false;
        this.audienceRequiresModel = false;
        this.queuedPatches = {};
        this.patchSubject = new Subject();
        (_b = (_a = this.patchFeed) === null || _a === void 0 ? void 0 : _a.feed) === null || _b === void 0 ? void 0 : _b.subscribe(p => {
            if (p.clientTag != this.clientTag)
                this.patchSubject.next(p);
        });
    }
    getRepositoryAudience(id, model) {
        return null;
    }
    get(id, options) {
        var _a, _b, _c;
        let headers = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.headers, (_b !== null && _b !== void 0 ? _b : new HttpHeaders()))
            .set("x-intellis-client-tag", this.clientTag);
        if ((_c = options) === null || _c === void 0 ? void 0 : _c.audience) {
            headers = headers
                .set("x-intellis-authorization-audience", options.audience);
        }
        else if (this.audienceAvailable && !this.audienceRequiresModel)
            headers = headers
                .set("x-intellis-authorization-audience", this.getRepositoryAudience(id, null));
        return this.http.get(this.config.apiBase + this.endpoint + '/' + id, { headers: headers });
    }
    getMany(ids, options) {
        var _a, _b, _c;
        let headers = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.headers, (_b !== null && _b !== void 0 ? _b : new HttpHeaders()))
            .set("x-intellis-client-tag", this.clientTag);
        if ((_c = options) === null || _c === void 0 ? void 0 : _c.audience) {
            headers = headers
                .set("x-intellis-authorization-audience", options.audience);
        }
        else if (this.audienceAvailable && !this.audienceRequiresId && !this.audienceRequiresModel)
            headers = headers
                .set("x-intellis-authorization-audience", this.getRepositoryAudience(null, null));
        let params = new HttpParams();
        ids.forEach(i => (params = params.append('ids', i.toString())));
        return this.http.get(this.config.apiBase + this.endpoint + '/many', { params: params, headers: headers });
    }
    post(model, options) {
        var _a, _b, _c;
        let headers = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.headers, (_b !== null && _b !== void 0 ? _b : new HttpHeaders()))
            .set("x-intellis-client-tag", this.clientTag);
        if ((_c = options) === null || _c === void 0 ? void 0 : _c.audience) {
            headers = headers
                .set("x-intellis-authorization-audience", options.audience);
        }
        else if (this.audienceAvailable && (!this.audienceRequiresId || model['id']))
            headers = headers
                .set("x-intellis-authorization-audience", this.getRepositoryAudience(model['id'], model));
        return this.http.post(this.config.apiBase + this.endpoint, model, { headers: headers });
    }
    put(id, model, options) {
        var _a, _b, _c;
        let headers = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.headers, (_b !== null && _b !== void 0 ? _b : new HttpHeaders()))
            .set("x-intellis-client-tag", this.clientTag);
        if ((_c = options) === null || _c === void 0 ? void 0 : _c.audience) {
            headers = headers
                .set("x-intellis-authorization-audience", options.audience);
        }
        else if (this.audienceAvailable)
            headers = headers
                .set("x-intellis-authorization-audience", this.getRepositoryAudience(id, model));
        return this.http.put(this.config.apiBase + this.endpoint, model, {
            params: new HttpParams().set("id", id.toString()),
            headers: headers
        });
    }
    delete(id, options) {
        var _a, _b, _c;
        let headers = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.headers, (_b !== null && _b !== void 0 ? _b : new HttpHeaders()))
            .set("x-intellis-client-tag", this.clientTag);
        if ((_c = options) === null || _c === void 0 ? void 0 : _c.audience) {
            headers = headers
                .set("x-intellis-authorization-audience", options.audience);
        }
        else if (this.audienceAvailable && !this.audienceRequiresModel)
            headers = headers
                .set("x-intellis-authorization-audience", this.getRepositoryAudience(id, null));
        return this.http.delete(this.config.apiBase + this.endpoint, {
            params: new HttpParams().set("id", id.toString()),
            headers: headers
        });
    }
    isCallback(patch) {
        return typeof patch === 'function';
    }
    isJsonPatch(patch) {
        if (Array.isArray(patch) && (patch.length ? patch[0].op : true)) {
            return true;
        }
        return false;
    }
    getOperations(model, patch) {
        if (this.isJsonPatch(patch)) {
            return patch;
        }
        else if (this.isCallback(patch)) {
            let copy = deepClone(model);
            patch(model);
            return compare(copy, model);
        }
        else {
            let arr = Array.isArray(patch) ? patch : [patch];
            return arr.map(p => ({ op: "replace", path: `/${p}`, value: model[p] }));
        }
    }
    _patch(id, model, operations, subject, options) {
        var _a, _b, _c;
        let headers = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.headers, (_b !== null && _b !== void 0 ? _b : new HttpHeaders()))
            .set("x-intellis-client-tag", this.clientTag);
        if ((_c = options) === null || _c === void 0 ? void 0 : _c.audience) {
            headers = headers
                .set("x-intellis-authorization-audience", options.audience);
        }
        else if (this.audienceAvailable)
            headers = headers
                .set("x-intellis-authorization-audience", this.getRepositoryAudience(id, model));
        let patchModel = {
            id: id,
            clientTag: this.clientTag,
            document: operations
        };
        return this.http.patch(`${this.config.apiBase}${this.endpoint}/${id}`, patchModel, { headers: headers }).pipe(tap(m => { var _a; return (_a = subject) === null || _a === void 0 ? void 0 : _a.next(m); }), tap(m => { var _a; return (_a = subject) === null || _a === void 0 ? void 0 : _a.complete(); }), 
        // Primarily to update the version, but also to apply other changes made on the server
        // But only do it if we're dealing with the actual model inteface
        tap(m => { if (!this.isModel || this.isModel(model))
            this.patchSubject.next({ id: id, clientTag: this.clientTag, document: compare(model, m) }); }));
    }
    patch(id, model, patch, options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        // Generate the operations if a callback was supplied
        let operations = this.getOperations(model, patch);
        // Clone for comparing to the work returned from the API, in case work changes in the meantime
        let clone = deepClone(model);
        // Sharing the patches locally?
        if ((_b = (_a = options) === null || _a === void 0 ? void 0 : _a.shareLocal, (_b !== null && _b !== void 0 ? _b : true)) || (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.localOnly, (_d !== null && _d !== void 0 ? _d : false)))
            this.patchSubject.next({ id: id, clientTag: this.clientTag, document: operations });
        if (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.localOnly, (_f !== null && _f !== void 0 ? _f : false))
            return of(model);
        // Check to see if there are existing operations queued, and add them to this patch if so
        let queued = this.queuedPatches[id.toString()];
        if (queued) {
            clearTimeout(queued.timeout);
            delete this.queuedPatches[id.toString()];
            // Filter out any replace operations that have been superseded to avoid sending unnecessary data
            // Technically this could upset some copy or move operations in the meantime, but they are unlikely to be queued
            let previous = queued.patch;
            operations.forEach(o => {
                previous = previous.filter(p => !(p.op == "replace" && p.path == o.path));
            });
            operations.unshift(...previous);
        }
        // If delayed, queue the patch for later
        if ((_g = options) === null || _g === void 0 ? void 0 : _g.delay) {
            let newQueued = {
                patch: operations,
                subject: (_j = (_h = queued) === null || _h === void 0 ? void 0 : _h.subject, (_j !== null && _j !== void 0 ? _j : new Subject())),
                timeout: setTimeout(() => {
                    var _a;
                    delete this.queuedPatches[id.toString()];
                    this._patch(id, clone, newQueued.patch, newQueued.subject, (_a = options) === null || _a === void 0 ? void 0 : _a.requestOptions).subscribe();
                }, options.delay)
            };
            this.queuedPatches[id.toString()] = newQueued;
            return newQueued.subject.pipe(share());
        }
        else {
            return this._patch(id, clone, operations, (_k = queued) === null || _k === void 0 ? void 0 : _k.subject, (_l = options) === null || _l === void 0 ? void 0 : _l.requestOptions);
        }
    }
    get patches() {
        return this.patchSubject.pipe(share());
    }
    keepUpdated(id, model) {
        return this.patchSubject.pipe(share(), filter(p => p.id == id), map(p => {
            if (model)
                applyPatch(model, p.document);
            return model;
        }));
    }
};
EntityRepository = __decorate([
    __param(3, Optional())
], EntityRepository);
let SearchableEntityRepository = class SearchableEntityRepository extends EntityRepository {
    constructor(config, http, endpoint, patchFeed = null) {
        super(config, http, endpoint, patchFeed);
        this.config = config;
        this.patchFeed = patchFeed;
    }
    getRepositoryAudience(id, model) {
        return null;
    }
    search(parameters, options) {
        var _a, _b, _c;
        let headers = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.headers, (_b !== null && _b !== void 0 ? _b : new HttpHeaders()))
            .set("Accept", "application/json")
            .set("x-intellis-client-tag", this.clientTag);
        if ((_c = options) === null || _c === void 0 ? void 0 : _c.audience) {
            headers = headers
                .set("x-intellis-authorization-audience", options.audience);
        }
        else if (this.audienceAvailable && !this.audienceRequiresId)
            headers = headers
                .set("x-intellis-authorization-audience", this.getRepositoryAudience(null, parameters));
        return this.http.get(this.config.apiBase + this.endpoint, {
            headers: headers,
            params: parameters,
        });
    }
    report(parameters, contentType = "text/csv", options) {
        var _a, _b, _c;
        let headers = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.headers, (_b !== null && _b !== void 0 ? _b : new HttpHeaders()))
            .set("Accept", contentType)
            .set("x-intellis-client-tag", this.clientTag);
        if ((_c = options) === null || _c === void 0 ? void 0 : _c.audience) {
            headers = headers
                .set("x-intellis-authorization-audience", options.audience);
        }
        else if (this.audienceAvailable && !this.audienceRequiresId)
            headers = headers
                .set("x-intellis-authorization-audience", this.getRepositoryAudience(null, parameters));
        return this.http.get(this.config.apiBase + this.endpoint, {
            responseType: 'blob',
            headers: headers,
            params: parameters,
        });
    }
    reportFile(parameters, contentType, options) {
        var _a, _b, _c;
        let headers = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.headers, (_b !== null && _b !== void 0 ? _b : new HttpHeaders()))
            .set("Accept", contentType)
            .set("x-intellis-client-tag", this.clientTag);
        if ((_c = options) === null || _c === void 0 ? void 0 : _c.audience) {
            headers = headers
                .set("x-intellis-authorization-audience", options.audience);
        }
        else if (this.audienceAvailable && !this.audienceRequiresId)
            headers = headers
                .set("x-intellis-authorization-audience", this.getRepositoryAudience(null, parameters));
        return this.http.get(this.config.apiBase + this.endpoint, {
            responseType: 'blob',
            headers: headers,
            params: parameters,
            observe: 'response'
        }).pipe(map(response => {
            const contentDisposition = response.headers.get('content-disposition');
            const fileName = contentDisposition.split(';')[1].trim().split('=')[1].replace(/"/g, '');
            const responseContentType = response.headers.get('content-type');
            return new File([response.body], fileName, { type: responseContentType });
        }));
    }
};
SearchableEntityRepository = __decorate([
    __param(3, Optional())
], SearchableEntityRepository);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RepositoryConfig, [{
        type: Injectable
    }], function () { return []; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PatchFeed, [{
        type: Injectable
    }], null, null); })();

/*
 * Public API Surface of entityrepository
 */

/**
 * Generated bundle index. Do not edit.
 */

export { EntityRepository, PatchFeed, Repository, RepositoryConfig, SearchableEntityRepository };

//# sourceMappingURL=intellis-entityrepository.js.map